<template>
  <el-dialog
    class="preview-dialog"
    :visible.sync="visible"
    @closed="destroyVideo"
  >
    <video
      v-if="src"
      :src="src"
      autoplay
      controls
      class="play-video"
    ></video>
  </el-dialog>
</template>

<script>
import preview from "./preview";
export default {
  data() {
    return {
      visible: false,
      src: ""
    };
  },
  mounted() {
    preview.$on("open-video", url => {
      this.src = url;
      this.visible = true;
    });
  },
  methods: {
    destroyVideo() {
      this.src = "";
    }
  }
};
</script>

<style lang="less" scoped>
.play-video {
  display: block;
  margin: 0 auto;
  max-height: 500px;
}
</style>